import React from "react";
import { useNavigate } from "react-router-dom";
import type { JSX } from "react";
import { Carousel, type CarouselResponsiveOption } from "primereact/carousel";
import { Divider } from "primereact/divider";
import { Fieldset } from "primereact/fieldset";
import { NewlyLaunchedProducts, type ProductShowcaseType} from "@/data/products";

function IntroSection({ opacity }: { opacity: number }): JSX.Element {
  return (
    <div className="h-full flex items-center justify-center snap-start" style={{ opacity }}>
      <div className="flex flex-col justify-between items-center text-4xl sm:text-6xl md:text-7xl lg:text-8xl">
        <div className="text-orange-400">Premium Electronics</div>
        <div className="flex flex-row gap-4">
          <div>for</div>
          <div className="text-yellow-300">Makers</div>
        </div>
        <div className="flex flex-row gap-4">
          <div>&</div>
          <div className="text-yellow-300">Hobbyists</div>
        </div>
      </div>
    </div>
  );
}

function ProductCard(product: ProductShowcaseType): JSX.Element {
  const navigate = useNavigate();

  return (
    <div className="flex justify-center items-center p-4">
      <Fieldset legend={product.name} className="w-full sm:w-72 pl-4 cursor-pointer shadow hover:shadow-lg transition" onClick={() => navigate(product.url)}>
        <div className="m-0">
          <img className="rounded-2xl" src={product.image} />
        </div>
        <Divider />
        <div className="text-center text-sm">{ product.description }</div>
      </Fieldset>
      {/* <Card title={product.name} header={<img className="w-64 h-64" src={product.image} />}></Card> */}
    </div>
  )
}

function ProductSection(): JSX.Element {
  const responsiveOpt: CarouselResponsiveOption[] = [
    {
      breakpoint: "1310px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "920px",
      numVisible: 1,
      numScroll: 1,
    }
  ];

  return (
    <div className="h-full w-full px-8 flex flex-col items-center justify-center snap-start">
      <div className="text-3xl sm:text-4xl md:text-6xl pb-8 md:pb-32">
        Newly Launched 
      </div>
      <div className="card w-full">
        <Carousel
          value={NewlyLaunchedProducts}
          numVisible={3}
          numScroll={1}
          itemTemplate={ProductCard}
          responsiveOptions={responsiveOpt}
        />
      </div>
    </div>
  )
}

export function Home() {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const [opacity, setOpacity] = React.useState(1);

  React.useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const handleScroll = () => {
      const scrollTop = el.scrollTop;
      const newOpacity = Math.max(1 - scrollTop / 400, 0);
      setOpacity(newOpacity);
    }

    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div ref={containerRef} className="w-full h-full overflow-y-scroll snap-y snap-mandatory">
      <IntroSection opacity={opacity} />
      <ProductSection />
    </div>
  );
}
